import { HttpService } from "@core/services/http.service.ts";
import { UserPostDTO, UserDTO } from "./user.model.ts";
import { apiURL } from "@utils/environment.ts";
import { PaginateResponse } from "@utils/appUtils.ts";

export type UserPostWithUserId = Omit<UserPostDTO, 'password'> & { uuid: string };

export class UserService extends HttpService {
  private APIURL = apiURL;

  saveUser(user: UserPostDTO) {
    this.urlAPI = this.APIURL + "/user";
    return this.doPost<UserDTO, UserPostDTO>(user);
  }

  searchUser(user: UserDTO) {
    this.urlAPI = this.APIURL + "/user";
    return this.doGetTerm<UserDTO[]>(user);
  }

  async findUserById(id: string): Promise<UserDTO> {
    this.urlAPI = `${this.APIURL}/user/keycloak/${id}`;
    return this.doGet<UserDTO>();
  }

  async findAllUser(): Promise<UserDTO[]> {
    this.urlAPI = `${this.APIURL}/user`;
    return this.doGet<UserDTO[]>();
  }

  editUser(id: string, user: UserPostWithUserId) {
    this.urlAPI = this.APIURL + "/user/" + id
    return this.doPut<any, UserPostWithUserId>(user);
  }

  deleteUser(id: string) {
    this.urlAPI = this.APIURL + "/user/" + id
    return this.doDelete<any>();
  }

  getUserWithPaginate(
    page: number,
    size: number,
    sortBy?: string,
    sortDir?: string,
    search?: string,
    profil?: string,
    access?: string,
    localisation?: string
  ) {
    const params = new URLSearchParams({
      page: page.toString(),
      size: size.toString(),
      sortBy: sortBy?.toString() ?? '',
      sortDir: sortDir?.toString() ?? '',
      search: search?.toString() ?? '',
      profil: profil?.toString() ?? '',
      access: access?.toString() ?? '',
      localisation: localisation?.toString() ?? '',
    });
    this.urlAPI = this.APIURL + `/user?${params}`;
    return this.doGet<PaginateResponse<UserDTO>>();
  }
  
  async getUserConnectedDetail(): Promise<UserDTO> {
    this.urlAPI = `${this.APIURL}/user/connectedUser`;
    return this.doGet<UserDTO>();
  }
}

export const userService = new UserService();
